module.exports = function() {
  return new Worker(__webpack_public_path__ + "fieldSettings.worker.a9b208f4.worker.js");
};